export const generateIdempotencyKey = () => crypto.randomUUID();
// `||` (not `??`) so the empty-string sentinel used by form state — "no active intent" —
// is treated the same as `undefined` and produces a fresh key.
export const resolveIdempotencyKey = (existing) => existing || generateIdempotencyKey();
